/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_len_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mile is defined as 5,280 feet, and a foot is exactly 0.3048 meters, so multiplying those out gives 1609.344 meters exactly. It looks awkward in metric because the mile was standardized from old British units, not designed around the meter.`)
};

const es_uc_len_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una milla se define como 5,280 pies, y un pie es exactamente 0.3048 metros, así que multiplicar esos números da exactamente 1609.344 metros. Se ve incómodo en métricas porque la milla se estandarizó a partir de unidades británicas antiguas, no fue diseñada alrededor del metro.`)
};

const de_uc_len_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Meile ist als 5,280 Fuß definiert, und ein Fuß sind exakt 0.3048 Meter — multipliziert man das aus, ergeben sich exakt 1609.344 Meter. Metrisch wirkt das unrund, weil die Meile aus alten britischen Einheiten standardisiert wurde und nicht um den Meter herum entworfen wurde.`)
};

const nl_uc_len_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een mijl is gedefinieerd als 5.280 voet, en een voet is exact 0,3048 meter, dus die vermenigvuldigen geeft precies 1609,344 meter. Het ziet er onhandig uit in metrische systeem omdat de mijl van oude Britse eenheden is gestandaardiseerd, niet ontworpen rond de meter.`)
};

const fr_uc_len_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un mile est défini comme 5 280 pieds, et un pied est exactement 0,3048 mètres, donc multiplier cela donne exactement 1609,344 mètres. C'est maladroit en métrique car le mile a été standardisé à partir d'anciennes unités britanniques, non conçu autour du mètre.`)
};

const it_uc_len_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un miglio è definito come 5.280 piedi e un piede è esattamente 0,3048 metri, quindi moltiplicando questi risultati in 1609.344 metri esattamente. Sembra complicato in metrico perché il miglio è stato standardizzato dalle vecchie unità britanniche, non progettato attorno al metro.`)
};

const pt_br2_uc_len_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma milha é definida como 5.280 pés, e um pé é exatamente 0.3048 metros, então multiplicar esses valores dá exatamente 1609.344 metros. Parece desajeitado em métrica porque a milha foi padronizada a partir de unidades britânicas antigas, não foi projetada em torno do metro.`)
};

const pt_uc_len_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma milha é definida como 5280 pés, e um pé é exactamente 0,3048 metros, portanto multiplicar esses valores dá exactamente 1609,344 metros. Parece desajustado em métrico porque a milha foi padronizada a partir de unidades britânicas antigas, não foi concebida em torno do metro.`)
};

const ja_uc_len_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイルは5,280フィートとして定義され、フィートは正確に0.3048メートルであるため、それらを乗じると正確に1609.344メートルになります。メートルに見えば不器用に見えるのは、マイルが古いイギリス単位から標準化されたもので、メートルの周りに設計されたのではないからです。`)
};

const zh_uc_len_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_len_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_len_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_len_faq2_a", locale)
	if (locale === "en") return en_uc_len_faq2_a(inputs)
	if (locale === "es") return es_uc_len_faq2_a(inputs)
	if (locale === "de") return de_uc_len_faq2_a(inputs)
	if (locale === "nl") return nl_uc_len_faq2_a(inputs)
	if (locale === "fr") return fr_uc_len_faq2_a(inputs)
	if (locale === "it") return it_uc_len_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_len_faq2_a(inputs)
	if (locale === "pt") return pt_uc_len_faq2_a(inputs)
	if (locale === "ja") return ja_uc_len_faq2_a(inputs)
	return zh_uc_len_faq2_a(inputs)
};